import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoModule } from '@jsverse/transloco';

import { PrismButtonComponent } from '@shure/prism-angular-components';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

@Component({
	selector: 'sh-discovery-error-dialog',
	templateUrl: './discovery-error-dialog.component.html',
	styleUrls: ['./discovery-error-dialog.component.scss'],
	imports: [
		CommonModule,
		FlexLayoutModule,
		MatDialogModule,
		MatCardModule,
		TranslocoModule,
		PrismButtonComponent,
		MatDividerModule
	],
	providers: [provideInlineScope('scDiscoveryErrorDialog', (lang) => import(`../i18n/${lang}`))]
})
export class DiscoveryErrorDialogComponent {
	constructor(private readonly matDialogRef: MatDialogRef<DiscoveryErrorDialogComponent>) {}

	public close(): void {
		this.matDialogRef.close();
	}
}
